import {NavigationTabsModuleTabModel} from "./navigation-tabs-module.tab-model";
import type {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import type {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {override} from "mobx";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";

export class DetailsTabModel extends NavigationTabsModuleTabModel {
  index: Number;
  name: String;
  entity: EntityViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: EntityViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @override get isVisible(): Boolean {
    return true;
  }

  get isActive(): Boolean {
    return !this.currentLinkModel.params.filter
  }

  get eventName(): String {
    return null
  }

  get eventParams(): Object {
    return null;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.details;
  }

  get elementId(): String {
    return 'navigation-tabs_scores';
  }
}
